import {Injectable} from "@angular/core";
import {HttpService} from "../technique/http.service";
import {UtilsService} from "../../utils/utils.service";
import {Observable} from "rxjs";
import {ResponseWrapper} from "../../suppliers/wrappers/response-wrapper";
import {HttpParams, HttpHeaders} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {saveAs as fs_saveAs} from "file-saver";
import {GestionAuthentificationDto} from "../../dtos/gestion-authentification/gestion-authentification-dto";
import {FilterFicheTechniqueModel} from "../../models/gestion-fiches-techniques/filter-fiche-technique-model";

export const URL_PURGE_INACTIVE_ARTICLE = 'dolrest/administration/purgeInactiveArticles';
export const URL_UPDATE_PRODUITS_ARTICLES = 'dolrest/administration/updateProduitsArticles';
export const URL_MAJ_ALLERGENES = 'dolrest/administration/majAllergenes';
export const URL_MAJ_FICHES_TECHNIQUES = 'dolrest/gestion-fiches-techniques/update/all-fiches-techniques';
export const URL_FIND_NUMBER_OF_DISHES_PRODUCED = 'dolrest/gestion-fiches-techniques/find/number-of-dishes-produced';
export const URL_UPDATE_ARTICLES_WITH_PERIODS_PRICE = 'dolrest/administration/updateArticlesWithPeriodPrice';
export const URL_GESTION_AUTHENTIFICATION = 'dolrest/administration/authentification';
export const URL_MAJ_BILLS = 'dolrest/administration/updateBills';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  constructor(private httpSvc: HttpService,
              public utils: UtilsService) { }

  /**
   * Suppression des articles inactifs
   * @returns {Observable<void>}
   */
  purgeInactiveArticles = (): Observable<ResponseWrapper<string>> => {
    return this.httpSvc.post(URL_PURGE_INACTIVE_ARTICLE, null);
  }

  /**
   * Mise à jour des produits articles
   * @returns {Observable<void>}
   */
  updateProduitsArticles = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.post(URL_UPDATE_PRODUITS_ARTICLES, null);
  }

  /**
   * Mise à jour des articles avec les périodes de prix
   * @returns {Observable<void>}
   */
  updateArticlesWithPeriodPrice = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.post(URL_UPDATE_ARTICLES_WITH_PERIODS_PRICE, null);
  }

  /**
   * Mise à jour des factures fournisseurs
   * @returns {Observable<void>}
   */
  updateBills = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.post(URL_MAJ_BILLS, null);
  }

  /**
   * Mise à jour des allergènes sur les produits
   * @returns {Observable<void>}
   */
  majAllergenes = () : Observable<ResponseWrapper<string>> => {
    return this.httpSvc.post(URL_MAJ_ALLERGENES, null);
  }

  /**
   * Suppression des articles inactifs
   * @returns {Observable<void>}
   */
  majFichesTechniques = (filter: FilterFicheTechniqueModel): Observable<ResponseWrapper<boolean>> => {
    return this.httpSvc.post(URL_MAJ_FICHES_TECHNIQUES, filter);
  }

  /**
   * Récupère le nombre de plats fabriqués
   * @returns {Observable<void>}
   */
  findNumberOfDishesProduced = (): Observable<ResponseWrapper<number>> => {
    return this.httpSvc.get(URL_FIND_NUMBER_OF_DISHES_PRODUCED);
  }

  getAuthInfos(): Observable<GestionAuthentificationDto[]> {
    return this.httpSvc.get(URL_GESTION_AUTHENTIFICATION);
  }

  saveAuthInfo(body: GestionAuthentificationDto): Observable<GestionAuthentificationDto> {
    return this.httpSvc.post(URL_GESTION_AUTHENTIFICATION, body)
  }

  deleteAuthInfo(gestionAuthentification: GestionAuthentificationDto): Observable<ResponseWrapper<boolean>> {
    return this.httpSvc.delete(URL_GESTION_AUTHENTIFICATION + '/' + gestionAuthentification.id).pipe(
      catchError(error => this.utils.handleError(error, true)));
  }

}
